// Maps canonical English values → Flutter emoji category strings
export const FLUTTER_CATS = {
  'home':        '🏠 Maison',
  'clothing':    '👕 Vêtements',
  'shoes':       '👟 Chaussures',
  'electronics': '📱 Électronique',
  'gaming':      '🎮 Jeux vidéo',
  'laptops':     '💻 Laptops',
  'cameras':     '📷 Caméras',
};

const CANONICAL = new Set(['home','clothing','shoes','electronics','gaming','laptops','cameras','other']);

// Converts any category string (English OR Flutter emoji) to canonical English value
export function normalizeCategory(raw) {
  if (!raw) return '';
  if (CANONICAL.has(raw)) return raw;
  const r = raw.toLowerCase();
  if (r.includes('maison')   || r.includes('home'))                        return 'home';
  if (r.includes('vêtement') || r.includes('vetement') || r.includes('clothing')) return 'clothing';
  if (r.includes('chaussure')|| r.includes('shoe'))                        return 'shoes';
  if (r.includes('électronique') || r.includes('electronique') || r.includes('electronic')) return 'electronics';
  if (r.includes('jeux')     || r.includes('gaming')   || r.includes('vidéo')) return 'gaming';
  if (r.includes('laptop')   || r.includes('ordinateur'))                  return 'laptops';
  if (r.includes('caméra')   || r.includes('camera')   || r.includes('photo'))  return 'cameras';
  return raw;
}

// Returns Firestore `in` array for user_products category query
export function catQueryValues(catValue) {
  const flutter = FLUTTER_CATS[catValue];
  return flutter ? [catValue, flutter] : [catValue];
}

// Returns product's canonical URL (handles Flutter `link`, React `productUrl`, eBay `itemUrl`)
export function productLink(p) {
  return p.link || p.productUrl || p.itemUrl || '';
}
